import { Route, Routes } from "react-router-dom";
import MainRoute from "./Pages/MainRoute/MainRoute";
import FirstStep from "./Pages/FirstStep";
import EmailPage from "./Pages/EmailPage";
import DownloadPage from "./Pages/DownloadPage";
import InviteCodePage from "./Pages/InviteCodePage";

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/invite/:code" element={<InviteCodePage />} />
        <Route path="*" element={<FirstStep />} />
      </Routes>
    </div>
  );
}

export default App;